module.exports = __webpack_public_path__ + "static/23-e1d93a497eb8b46d9014b5cf4041eab7.png";